import { FILE_UPLOAD_ACTIONS, QUEST_ACTION } from '../../../constants/actions'
import { buildFileUrl } from '../../../util/brand.helpers'
import { mergeToNewObject } from '../../../util/object.helpers'
import { populateQuestForm } from '../../../util/quest.helpers'
import { buildErrorMessage } from '../../../util/reducer.helpers'

export const questProfile = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case QUEST_ACTION.CHANGE_STATE:
      return mergeToNewObject(state, {
        [payload.property]: payload.value,
        ...(payload.property === QUEST_PROFILE_DISPATCH.AMOUNT_TEMP && {
          error: {
            ...state.error,
            amountTemp: null
          }
        })
      })

    case QUEST_ACTION.ON_CREATE_INIT_QUEST:
    case QUEST_ACTION.ON_CREATE_QUEST:
      return mergeToNewObject(state, {
        isProcessing: true,
        saveSuccess: false
      })

    case QUEST_ACTION.ON_CREATE_QUEST_SUCCESS:
      return mergeToNewObject(state, {
        ...INITIAL_STATE,
        isProcessing: false,
        saveSuccess: true
      })

    case QUEST_ACTION.ON_UPDATE_INIT_QUEST:
    case QUEST_ACTION.ON_UPDATE_QUEST:
      return mergeToNewObject(state, {
        isProcessing: true,
        saveSuccess: false
      })

    case QUEST_ACTION.ON_UPDATE_QUEST_SUCCESS:
      return mergeToNewObject(state, {
        isProcessing: false,
        saveSuccess: true
      })

    case QUEST_ACTION.ON_UPDATE_QUEST_FAILED:
      return mergeToNewObject(state, {
        isProcessing: false,
        saveSuccess: false
      })

    case QUEST_ACTION.ON_CREATE_QUEST_FAILED:
      return mergeToNewObject(state, {
        isProcessing: false,
        error: {
          titleTemp: buildErrorMessage(payload)
        },
        saveSuccess: false
      })

    case FILE_UPLOAD_ACTIONS.ON_UPLOAD_FILE_FAILED:
      return mergeToNewObject(state, {
        isProcessing: false,
        error: {
          [QUEST_PROFILE_DISPATCH.MEDIA]: buildErrorMessage(
            null,
            `error.failed-to-upload-media`
          )
        }
      })

    case FILE_UPLOAD_ACTIONS.ON_GET_PRESIGNED_URL_FAILED:
      return mergeToNewObject(state, {
        isProcessing: false,
        error: {
          [QUEST_PROFILE_DISPATCH.MEDIA]: buildErrorMessage(
            null,
            'quest.try-again-types-list'
          )
        }
      })

    case QUEST_ACTION.ON_SELECT:
      const { data, isListUpdate } = payload
      return mergeToNewObject(
        state,
        data && !isListUpdate ? populateQuestForm(data) : {}
      )

    case FILE_UPLOAD_ACTIONS.ON_UPLOAD_FILE_SUCCESS:
      return mergeToNewObject(state, { mediaUrlTemp: buildFileUrl(payload) })

    case QUEST_ACTION.RESET_STATE:
      return INITIAL_STATE

    default:
      return state
  }
}

const INITIAL_STATE = {
  error: '',
  isProcessing: false,

  saveSuccess: false,

  media: '',
  mediaUrl: '',
  mediaUrlTemp: '',

  title: '',
  amount: '',
  url: '',
  description: '',
  startDate: '',
  endDate: '',

  titleTemp: '',
  amountTemp: '',
  urlTemp: '',
  descriptionTemp: '',
  startDateTemp: '',
  endDateTemp: ''
}

export const QUEST_PROFILE_DISPATCH = {
  ERROR: 'error',
  MEDIA: 'media',
  MEDIA_URL_TEMP: 'mediaUrlTemp',
  TITLE_TEMP: 'titleTemp',
  AMOUNT_TEMP: 'amountTemp',
  URL_TEMP: 'urlTemp',
  DESCRIPTION_TEMP: 'descriptionTemp',
  START_DATE_TEMP: 'startDateTemp',
  END_DATE_TEMP: 'endDateTemp'
}
